import { api, handleResponse, handleError } from "./apiServices";

export const addVenue = (token, data) =>
  api(token)
    .post(`api/venues/`, data)
    .then(handleResponse)
    .catch(handleError);
export const getVenues = (token, data) =>
  api(token)
    .get(`api/venues/`, { params: data })
    .then(handleResponse)
    .catch(handleError);
export const getVenueById = (token, id) =>
  api(token)
    .get(`api/venues/${id}`)
    .then(handleResponse)
    .catch(handleError);
export const deleteVenue = (token, id) =>
  api(token)
    .delete(`api/venues/${id}`)
    .then(handleResponse)
    .catch(handleError);
export const editVenue = (token, id, data) =>
  api(token)
    .put(`api/venues/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
export const changeStatus = (token, id, data) =>
  api(token)
    .patch(`api/venues/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
export const getAllVenues = token =>
  api(token)
    .get(`api/venues/get-all-venues`)
    .then(handleResponse)
    .catch(handleError);
